var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"view-question-container"},[_c('div',[_c('b-dropdown',{attrs:{"text":"Select","varient":"none"}},_vm._l((_vm.content.options),function(opt){return _c('div',[_c('b-dropdown-item',{staticClass:"p-1"},[_vm._v(_vm._s(opt))])],1)}),0)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4497abcc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/survey-create/search-templates-components/ViewDropdown.vue
// module id = null
// module chunks = 